import { ControlVariableDefinition } from 'libs/end-to-end/src/types/databases/controls/control-variable';
import { NumericalTraitDefinition } from 'libs/end-to-end/src/types/databases/controls/control-variable';

export const numericalTraitDefinition = (
  overrides?: Partial<NumericalTraitDefinition>,
): NumericalTraitDefinition => {
  return {
    unitSingular: 'unit',
    unitPlural: 'units',
    denominator: 1,
    ...(overrides ?? {}),
  };
};

export const numericalControlVariableDefinition = (
  overrides?: Partial<ControlVariableDefinition>,
): ControlVariableDefinition => {
  return {
    columnHeaderValue: 'industryExperience',
    displayName: 'Industry experience',
    dataType: 'numeric',
    transformationType: 'none',
    numericalTraitDefinition: numericalTraitDefinition(),
    ...(overrides ?? {}),
  };
};

export const categoricalControlVariableDefinition = (
  overrides?: Partial<ControlVariableDefinition>,
): ControlVariableDefinition => {
  return {
    columnHeaderValue: 'negoriationSkills',
    displayName: 'Negotiation Skills',
    dataType: 'categorical',
    transformationType: 'none',
    ...(overrides ?? {}),
  };
};
